<div class="sr-only" aria-live="polite" aria-atomic="true" role="status">
  <ng-container *ngIf="{ total: total$ | async } as data">
    <ng-container *ngIf="isNumber(data.total)">
      <ng-content></ng-content>
      <span i18n="@@sr-search-result-info-label.someValue">
        {data.total, plural, =0 {No results found} =1 {1 result found} other {{{data.total}} results found}}
      </span>
    </ng-container>
  </ng-container>
</div>

